const variables = Object.entries(process.env)
const envVariables = variables
    .filter(([key]) => key.startsWith('REACT_APP_VAR_'))
    .reduce((acc, [key, value]) => {
        const featureKey = key.replace(/^REACT_APP_VAR_/, '')
        acc[featureKey] = value
        return acc
    }, {})

export const VARIABLES = Object.keys(envVariables).reduce((acc, key) => {
    acc[key] = key
    return acc
}, {})

export default function getEnvVariableValue(featureName) {
    return envVariables[featureName]
}
